module.exports = __webpack_public_path__ + "img/jobs_files_tab.063d9a7a.svg";